<template>
  <b-modal :id="modal_id" :title="title" size="lg">
    <ticket-form v-if="!ticket" ref="ticket-form" @onSaved="onSaved" @onFail="saving = false"></ticket-form>
    <ticket-details v-if="ticket" :ticket="ticket"></ticket-details>
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      <b-button-group>
        <b-overlay :show="saving" spinner-small>
          <b-button v-if="!ticket" variant="outline-success" squared @click="save"><font-awesome-icon :icon="['fal', 'paper-plane']"></font-awesome-icon></b-button>
        </b-overlay>
        <b-button v-if="ticket" variant="outline-dark" squared @click="reset">Create Another</b-button>
      </b-button-group>
    </template>
  </b-modal>
</template>

<script>
  import TicketForm from "./TicketForm";
  import TicketDetails from "./TicketDetails";

  export default {
  name: 'TicketModal',
    components: {TicketDetails, TicketForm},
    props: ['modal_id'],
    data() {
    return {
      title: 'Submit a ticket',
      ticket: null,
      saving: false,
    };
  },
  methods: {
    reset() {
      this.title = 'Submit a ticket';
      this.ticket = null;
      this.saving = false;
    },
    save() {
      this.saving = true;
      this.$refs['ticket-form'].save();
    },
    onSaved: function(ticket) {
      this.title = 'Ticket #' + ticket.number + ' submitted successfully';
      this.ticket = ticket;
      this.saving = false;
    },
  }
}
</script>
